import { render, staticRenderFns } from "./VideoSquareTile.vue?vue&type=template&id=04d2fbf7"
import script from "./VideoSquareTile.vue?vue&type=script&lang=js"
export * from "./VideoSquareTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports